<mat-icon [direction]="direction" *ngIf="type === IconType.MaterialDesign">{{name}}</mat-icon>
<img [direction]="direction" *ngIf="type === IconType.Image" [src]="name" alt="" />
<svg-icon [direction]="direction" *ngIf="type === IconType.SVG" [key]="name"></svg-icon>
<!--<ng-container *ngIf="type === IconType.SVG">{{name}}</ng-container>-->
